import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Divider from "@mui/material/Divider";
import {
  Document,
  Image,
  PDFViewer,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";

import Button from "@mui/material/Button";
import moment from "moment";
import { useSelector } from "react-redux";
import logo from "../../assets/images/logo.png";

const DownloadPDFDataTable = ({
  fileName = "",
  data = [],
  columns = [],
  toDate = null,
  fromDate = null,
  isOpen,
  onClose,
}) => {
  const { activeSession } = useSelector(({ auth }) => auth);

  const Table = ({ children }) => (
    <View
      style={{
        marginTop: 8,
        marginBottom: 8,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </View>
  );

  const TableRow = ({ children }) => (
    <View
      wrap={false}
      style={{
        display: "flex",
        flexDirection: "row",
        textAlign: "right",
        borderBottom: "1px solid #e5e5e5",
      }}
    >
      {children}
    </View>
  );

  const TableRowNoLine = ({ children }) => (
    <View
      wrap={false}
      style={{
        display: "flex",
        flexDirection: "row",
        textAlign: "right",
      }}
    >
      {children}
    </View>
  );

  const TableHeader = ({ children }) => (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        textAlign: "center",
        color: "#111111",
        backgroundColor: "#e9e9e9",
      }}
    >
      {children}
    </View>
  );

  const TableCell = ({ children }) => (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 5,
        paddingVertical: 10,
        fontSize: 8,
        textAlign: "left",
        overflow: "hidden",
      }}
    >
      <Text>{children}</Text>
    </View>
  );

  const TableCellSn = ({ children }) => (
    <View
      style={{
        flex: 0.4,
        paddingHorizontal: 5,
        paddingVertical: 10,
        fontSize: 8,
        textAlign: "left",
        overflow: "hidden",
      }}
    >
      <Text>{children}</Text>
    </View>
  );

  const TableCellRightAlign = ({ children }) => (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 5,
        paddingVertical: 10,
        fontSize: 8,
        textAlign: "right",
        overflow: "hidden",
      }}
    >
      <Text>{children}</Text>
    </View>
  );

  const TableCellCenterAlign = ({ children }) => (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 5,
        paddingVertical: 10,
        fontSize: 8,
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <Text>{children}</Text>
    </View>
  );

  const TableCellHeader = ({ children }) => (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 5,
        paddingVertical: 10,
        fontSize: 9,
        textAlign: "left",
      }}
    >
      <Text>{children}</Text>
    </View>
  );

  const TableCellHeaderSn = ({ children }) => (
    <View
      style={{
        flex: 0.4,
        paddingHorizontal: 5,
        paddingVertical: 10,
        fontSize: 9,
        textAlign: "left",
      }}
    >
      <Text>{children}</Text>
    </View>
  );

  const TableWhiteSpace = () => {
    return (
      <View
        style={{
          width: "100%",
          height: 20,
        }}
      ></View>
    );
  };

  const styles = StyleSheet.create({
    page: {
      backgroundColor: "#ffffff",
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },

    image: {
      height: 80,
      width: 150,
      marginVertical: 15,
      marginHorizontal: 100,
    },
    imageLogo: {
      alignSelf: "center",
      height: 75,
      width: 75,
      marginBottom: 10,
    },
    cellBackground: {
      backgroundColor: "#dddddd",
    },
    subtitle: {
      textAlign: "center",
      marginBottom: 5,
      fontSize: 12,
    },

    padded: {
      padding: 20,
    },

    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 20,
      fontWeight: 800,
      textAlign: "center",
      textDecoration: "none",
      marginBottom: 10,
    },
    downloadLink: {
      textDecoration: "none",
      color: "unset",
    },
  });

  const BuildPDF = () => {
    return (
      <Document>
        <Page orientation="landscape" style={styles.padded}>
          <Image style={styles.imageLogo} src={logo} />
          <Text style={styles.title}>BANK OF TANZANIA</Text>
          <Text style={styles.title}>LIBRARY</Text>
          <Table>
            <TableRowNoLine>
              <TableCell>
                {fromDate !== null && toDate !== null && (
                  <>
                    {" "}
                    Date Range: From {fromDate} to {toDate}
                  </>
                )}
              </TableCell>
              <TableCellRightAlign>
                Run by: {activeSession.userId}
              </TableCellRightAlign>
            </TableRowNoLine>
            <TableRowNoLine>
              <TableCell></TableCell>
              <TableCellRightAlign>
                Date: {moment().format("DD-MMM-YYYY")} Time:{" "}
                {moment().format("h:mm:ss a")}
              </TableCellRightAlign>
            </TableRowNoLine>
          </Table>
          <TableWhiteSpace />
          <Text style={styles.subtitle}>{fileName.toUpperCase()}</Text>
          <Table>
            <TableHeader>
              <TableCellHeaderSn key={`header-sn`}>S/N</TableCellHeaderSn>
              {columns.map((column, index) => (
                <TableCellHeader key={`header-${index}`}>
                  {column.label}
                </TableCellHeader>
              ))}
            </TableHeader>

            {data.map((row, rowIndex) => (
              <TableRow key={`row-${rowIndex}`}>
                <TableCellSn key={`row-${rowIndex}-col-sn`}>
                  {rowIndex + 1}
                </TableCellSn>
                {columns.map((col, colIndex) =>
                  (() => {
                    // return (
                    //   <TableCell key={`row-${rowIndex}-col-${colIndex}`}>
                    //     {/* {row[col.name] ?? ""} */}
                    //     {JSON.stringify(col?.options)}
                    //   </TableCell>
                    // );

                    if ((col?.options?.align || "left") === "center") {
                      return (
                        <TableCellCenterAlign
                          key={`row-${rowIndex}-col-${colIndex}`}
                        >
                          {row[col.name] ?? ""}
                        </TableCellCenterAlign>
                      );
                    } else if ((col?.options?.align || "left") === "left") {
                      return (
                        <TableCell key={`row-${rowIndex}-col-${colIndex}`}>
                          {row[col.name] ?? ""}
                        </TableCell>
                      );
                    } else if ((col?.options?.align || "left") === "right") {
                      return (
                        <TableCellRightAlign
                          key={`row-${rowIndex}-col-${colIndex}`}
                        >
                          {row[col.name] ?? ""}
                        </TableCellRightAlign>
                      );
                    } else {
                      return (
                        <TableCell key={`row-${rowIndex}-col-${colIndex}`}>
                          {row[col.name] ?? ""}
                        </TableCell>
                      );
                    }
                  })()
                )}
              </TableRow>
            ))}
          </Table>
        </Page>
      </Document>
    );
  };

  return (
    // <PDFDownloadLink
    //   style={styles.downloadLink}
    //   document={<BuildPDF />}
    //   fileName={`${fileName}.pdf`}
    // >
    //   {({ blob, url, loading, error }) => (
    //     <>
    //       {!loading && <div style={styles.downloadLink}>Download PDF</div>}
    //       {loading && (
    //         <div
    //           style={{ width: "100px" }}
    //           className="flex-row justify-content-center align-items-center"
    //         >
    //           <CircularProgress size={11} color="primary" />
    //         </div>
    //       )}
    //     </>
    //   )}
    // </PDFDownloadLink>
    // <PDFViewer>
    //   <BuildPDF />
    // </PDFViewer>

    <Dialog
      fullWidth={true}
      maxWidth={"xl"}
      // disableBackdropClick={true}
      // disableEscapeKeyDown={true}
      open={isOpen}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogContent>
        <DialogContentText style={{ height: "calc( 100vh - 100px )" }}>
          <PDFViewer width="100%" height="100%" showToolbar={true}>
            <BuildPDF />
          </PDFViewer>
        </DialogContentText>
        <Divider />
      </DialogContent>
      <DialogActions>
        {/* <Button
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          disabled={
            (method === "new" ? false : !isFormEdited) ||
            (status === "posting" ? true : false)
          }
          variant="contained"
          color="primary"
          id="btn-submit"
        >
          {status === "posting" ? (
            <CircularProgress size={20} />
          ) : (
            <>
              <SaveIcon className="app-button-icon" /> &nbsp;
              {method === "new" ? "SAVE" : "UPDATE"}
            </>
          )}
        </Button>
        */}
        <Button
          id="btn-close"
          variant="contained"
          onClick={() => {
            onClose();
          }}
          color="secondary"
          size="small"
        >
          <CloseIcon fontSize="small" className="app-button-icon" />
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadPDFDataTable;
